import React, { useEffect, useState } from 'react'
import powerAppsLogo from '../assets/img/powertools-logo.png'
import { Link } from 'react-router-dom';

const Register = () => {
  
  const [loader, setLoader] = useState(true)
  
  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  });
  
  return (
    <>
    {
      loader ? <div className='waterfall'><div></div><div></div><div></div><div></div><div></div></div>
      : 
      <div className='fade-in'>
        <section className='bg-dark vh-100'>
          <div className='container h-100'>
            <div className='col-12 d-flex justify-content-center align-items-center h-100'>
              <div className='col-md-6 col-lg-4'>
                <div className='card shadow-sm border-radius-none'>
                  <div className='card-body pb-5'>
                    <div className='col-12 text-center mt-4 mb-5'>
                      <Link to='/'><img src={powerAppsLogo} width="auto" height="60px"/></Link>
                    </div>
                    <div className='col-12 px-4'>
                    <h4 className='mb-4 text-center'>REGISTER</h4>
                      <div className='col-12 mb-4'>
                        <label className='ps-0 mb-2'>Name</label>
                        <input type='text' className='form-control py-2'/>
                      </div>
                      <div className='col-12 mb-4'>
                        <label className='ps-0 mb-2'>Email ID</label>
                        <input type='email' className='form-control py-2'/>
                      </div>
                      <div className='col-12 mb-4'>
                        <label className='ps-0 mb-2'>Password</label>
                        <input type='password' className='form-control py-2'/>
                      </div>
                      <div className='col-12 mb-4'>
                        <label className='ps-0 mb-2'>Confirm Password</label>
                        <input type='password' className='form-control py-2'/>
                      </div>
                    </div>
                    <div className='col-12 px-4 mt-4'>
                      <Link to='/dashboard' className='btn btn-dark border-radius-none px-5 py-3 mb-3 w-100'>REGISTER</Link>
                      <Link to='/login' className='btn btn-outline-dark border-radius-none px-5 py-3 w-100'>LOGIN</Link>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    }
        
    </>
  )
}

export default Register